/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetCompletionFeedbackRequest = {
  id: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetCompletionFeedbackRequest$inboundSchema: z.ZodType<
  GetCompletionFeedbackRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetCompletionFeedbackRequest$Outbound = {
  id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetCompletionFeedbackRequest$outboundSchema: z.ZodType<
  GetCompletionFeedbackRequest$Outbound,
  z.ZodTypeDef,
  GetCompletionFeedbackRequest
> = z.object({
  id: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getCompletionFeedbackRequestToJSON(
  getCompletionFeedbackRequest: GetCompletionFeedbackRequest,
): string {
  return JSON.stringify(
    GetCompletionFeedbackRequest$outboundSchema.parse(
      getCompletionFeedbackRequest,
    ),
  );
}
export function getCompletionFeedbackRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetCompletionFeedbackRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetCompletionFeedbackRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetCompletionFeedbackRequest' from JSON`,
  );
}
